import React from "react";
import "../styles/Termsconditions.css";
import termsImage from "../assets/T&C.png";
const TermsConditions = () => {
  return (
    <div className="terms-page">
      <div className="terms-container">
        <div className="terms-content">
          <header className="contact-header">
            <section
              className="hero-section"
              style={{
                width: "100%",
                backgroundImage: `url(${termsImage})`,
              }}
            >
              <div className="hero-overlay">
                <div className="hero-content">
                  <h1 className="refund-main-title">Terms & Conditions</h1>{" "}
                </div>
              </div>
            </section>
          </header>
          <div className="section-title">
            <h5>Terms & Conditions</h5>
          </div>

          <div className="content-box">
            <p>
              Please read these Terms carefully before placing an order for
              Products with the Vendors ("We" or "Our" or "Us", as applicable)
              on PixelTools.com (the Website). These Terms constitute your
              agreement to be bound by these Terms.
            </p>

            <p>
              If you use any current or future pixeltools.com service (e.g.
              Wishlist or Marketplace or Pixel Tools Service), you will also be
              subject to the terms, conditions and policies applicable to that
              service ("Terms"). If these Terms of Sale are inconsistent with
              these Terms, the Terms shall prevail.
            </p>
          </div>

          <div className="section-title">
            <h5>1. Terms relating to the sale of products to you</h5>
          </div>

          <div className="content-box">
            <p>
              This section deals with the Terms relating to the sale of products
              on the Website by us to you.
            </p>
          </div>

          <div className="section-title">
            <h5>2. Our contract</h5>
          </div>

          <div className="content-box">
            <p>
              Your order is an offer to us to buy the product(s) in your order.
              When you place an order to purchase a product from us, you will
              receive an e-mail confirming receipt of your order and containing
              the details of your order (the "Order Confirmation Email"). The
              Order Confirmation Email is a confirmation that we have received
              your order and is not a confirmation of acceptance of your offer
              to purchase the product(s) ordered. We will only accept your offer
              and enter into the contract of sale for a product ordered by you
              when the product is dispatched to you and you receive an e-mail
              confirmation that the product has been dispatched to you (the
              "Dispatch Confirmation Email"). If your order is shipped in
              multiple packages, you may receive a separate shipping
              confirmation for each package, and each shipping confirmation and
              corresponding shipment will form a separate contract of sale
              between you and us for the product(s) specified in that shipping
              confirmation.
            </p>

            <p>
              Your contract is with us (the sellers) and you confirm that you
              have purchased the product(s) you have ordered for your
              internal/personal use and not for resale or business purposes. You
              authorize us to declare on your behalf and declare to any
              government authority the above intended use of the product(s)
              ordered by you from the Website.
            </p>

            <p>
              You may cancel your order for a product free of charge at any time
              before we send the shipping confirmation for that product by
              e-mail.
            </p>

            <p>
              Please note that we only sell products in quantities that
              correspond to the typical requirements of an average household.
              This applies both to the number of products ordered within a
              single order and to the placing of multiple orders for the same
              product if the individual orders comprise a quantity typical of a
              normal household.
            </p>
          </div>

          <div className="section-title">
            <h5>3. Returns</h5>
          </div>

          <div className="content-box">
            <p>
              Most items purchased from sellers listed on PixelTools.com cannot
              be returned within the return period, except for those items
              specifically marked as returnable. Returns will only be processed
              if:
            </p>

            <ul>
              <li>
                It is established that the product was not damaged while it was
                in your possession;
              </li>
              <li>
                The product is not different from what was shipped to you;
              </li>
              <li>
                The product is returned in its original condition (with
                brand/manufacturer box, MRP tag intact, user manual, warranty
                card, and accessories).
              </li>
            </ul>
          </div>

          <div className="section-title">
            <h5>4. Pricing and availability</h5>
          </div>

          <div className="content-box">
            <p>
              We list availability information for the products we sell on the
              Site, including on each product information page. Beyond what we
              state on this page or elsewhere on the Website, we are unable to
              provide more specific availability information. Please note that
              estimated shipping times are estimates only. They are not
              guaranteed shipping times and should not be relied upon as such.
              While we are processing your order, you will be notified by e-mail
              if a product you have ordered is not available.
            </p>

            <p>
              For further details, please refer to our pricing policy and
              availability guide, both of which apply to products ordered from
              us.
            </p>

            <p>
              All prices are inclusive of VAT/CST, Service Tax, Goods and
              Services Tax ("GST"), duties, and levies - unless otherwise
              stated.
            </p>
          </div>

          <div className="section-title">
            <h5>5. Taxes</h5>
          </div>

          <div className="content-box">
            <p>
              You are responsible for paying all fees/costs/duties associated
              with the purchase of products from us and you agree to bear all
              applicable taxes, including but not limited to VAT/CST, Service
              Tax, GST, duties, and levies etc.
            </p>
          </div>

          <div className="section-title">
            <h5>6. Health & Safety</h5>
          </div>

          <div className="content-box">
            <p>
              By purchasing a product from our Home & Kitchen store, you
              acknowledge that you have read and understood our Health & Safety
              Policy.
            </p>
          </div>

          <div className="section-title">
            <h5>7. Children</h5>
          </div>

          <div className="content-box">
            <p>
              The use of PixelTools.com is available only to persons who can
              form a legally binding contract under the Indian Contract Act,
              1872. If you are a minor, i.e. under 18 years of age, you may
              purchase only with the involvement of a parent or guardian.
            </p>
          </div>

          <div className="section-title">
            <h5>8. Communication</h5>
          </div>

          <div className="content-box">
            <p>
              When you visit PixelTools.com, you are communicating with us
              electronically. When you place an order with us, you must provide
              a valid phone number. We may communicate with you by e-mail, text
              message, phone call, or by posting notices on the website or by
              other means of communication. For contractual purposes, you agree
              that we may notify you by SMS, email, or phone call in connection
              with your order.
            </p>
          </div>

          <div className="section-title">
            <h5>9. Losses</h5>
          </div>

          <div className="content-box">
            <p>
              We will not be liable for any business losses (including loss of
              profits, revenue, contracts, anticipated savings, data, goodwill
              or wasted expenditure) or any other indirect or consequential loss
              that was not foreseeable to you and us at the time we entered into
              a contract for the sale of goods to you.
            </p>
          </div>

          <div className="section-title">
            <h5>10. Changes or additions to the Terms</h5>
          </div>

          <div className="content-box">
            <p>
              We reserve the right to make changes to our policies and these
              Conditions of Sale at any time. You will be subject to the
              policies and terms of sale in force at the time you order goods
              from us, unless a change to those policies or terms is required by
              law or regulation (in which case it will apply to orders
              previously placed by you). If any of these terms are invalid,
              void, or for any reason unenforceable, that term shall be deemed
              severable and shall not affect the validity and enforceability of
              any remaining terms.
            </p>
          </div>

          <div className="section-title">
            <h5>11. Events beyond our control</h5>
          </div>

          <div className="content-box">
            <p>
              We will not be liable for any delay or failure to perform our
              obligations under these Terms if the delay or failure is due to
              any cause beyond our reasonable control. This condition does not
              affect your statutory rights.
            </p>
          </div>

          <div className="section-title">
            <h5>12. Waiver</h5>
          </div>

          <div className="content-box">
            <p>
              If you breach these Terms and we take no action, we will still be
              entitled to exercise our rights and remedies in any other
              situation where you breach these Terms.
            </p>
          </div>

          <div className="section-title">
            <h5>13. Governing law and jurisdiction</h5>
          </div>

          <div className="content-box">
            <p>
              These Terms shall be governed by and construed in accordance with
              the laws of India and the application of the United Nations
              Convention on Contracts for the International Sale of Goods is
              expressly excluded. You agree, as we do, to submit to the
              exclusive jurisdiction of the courts of Delhi.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsConditions;
